<template>
  <div class="AdvertisementGeneralDetails">
    <div class="infoAd">
      <Card :title="$t('advertisement.name-advertisement')">
        <Picture class="img" name="new"/>
        <p class="infoAd__name" v-text="advertisement.name"
      />
      </Card>
      <Card :title="$t('advertisement.investment')">
        <Picture class="img" name="budget"/>
        <span>
        <p v-text="advertisement.investment"/>
        <p class="dollar" v-text="'$'" />
          </span>
      </Card>
    </div>
    <div class="metric">
      <Card :title="$t('advertisement.effectiveness')">
        <div class="metric__Effectiveness">
          <p v-text="`${advertisement.investment}${'%'}`"/>
          <i class="icon-arrow-left"></i>
          <span v-text="'0%'" />
        </div>
        <BarChart
                :height="130"
                :options="optionsBarChart"
                :series="seriesBarChart"
                :width="150"
                type="bar"
        />
      </Card>
      <Card :title="$t('advertisement.cost-action')">
        <div class="metric__action">
        <p v-text="advertisement.actions" />
        <p class="dollar" v-text="'$'"/>
        <i class="icon-arrow-left"></i>
        <span v-text="'0%'" />
        </div>
      <BarChart
              :height="130"
              :options="optionsGreen"
              :series="seriesBarChart"
              :width="150"
              type="bar"
      />
    </Card>
    </div>
  </div>
</template>

<script>
  import BarChart from 'vue-apexcharts';
import { Picture } from 'daas-components';
import { Card } from '@/components';
import Vuei18n from '@/translations';
import { getAdvertisementDetail } from '@/api';

const headers = [
  {
    id: 'name',
    label: Vuei18n.t('dashboard.name'),
  },
  {
    id: 'investment',
    label: Vuei18n.t('dashboard.investment'),
  },
  {
    id: 'state',
    label: Vuei18n.t('dashboard.state'),
  },
];
export default {
  name: 'AdvertisementGeneralDetails',
  data() {
    return {
      advertisement: {},
      headers,
      seriesBarChart :[{
        name: "Series 1",
        data: [45, 52, 38, 24, 33, 26]
      },],
      optionsBarChart :{
        chart: {
          toolbar: {
            show: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        grid:{
          show: false,
        },
        yaxis:{
          show:false,
        },
        xaxis:{
          labels:{
            show:false,
          },
          axisBorder: {
            show: false,
          }
        },
      },
      optionsGreen:{
        colors:['#95c623'],
        chart: {
          toolbar: {
            show: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        grid:{
          show: false,
        },
        yaxis:{
          show:false,
        },
        xaxis:{
          labels:{
            show:false,
          },
          axisBorder: {
            show: false,
          }
        },
      },
    };
  },
  components: {
    Card,
    Picture,
    BarChart,
  },
  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
    series: {
      type: Array,
      default: () => ([])
    },
    width: {
      type: Number,
      default: 90,
    },
  },
  mounted() {
    getAdvertisementDetail(this.$route.params.businessId,this.$route.params.id).then(
            data => {
              this.advertisement = data
            },
            err => {
              console.log('Fetch Error: ', err);
            }
    );
  },
};
</script>

<style lang="scss">
.AdvertisementGeneralDetails {
  display: grid;
  justify-content: center;
  .infoAd {
    display: flex;
    .Card {
      width: 100%;
      .Picture {
        height: rem(70);
      }
      p {
        font-size: rem(35);
      }
    }
  }
  .metric{
    display: flex;
    align-items: center;
    p {
      font-size: rem(35);
      font-weight: 700;
      margin-right: 10px;
    }
    span{
      font-size: rem(20);
      font-weight: 600;
    }
    i{
      font-size: rem(10);
      font-weight: 700;
    }
      &__Effectiveness{
        display: flex;
        align-items: center;
        span, i{
          color:$blue-400;
        }
      }
      &__action{
        display: flex;
        align-items: center;
        span, i{
          color:$success;
        }
      }

  }
  .Card {
    min-width: 300px;
    padding: rem(0) rem(10);
    margin: rem(10);
    span{
      display: flex;
    }
  }
  .dollar{
    font-weight: 700;
  }
}
</style>
